<template>
  <swiper-content isProduct :contentEnabled="contentEnabled">
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout page-layout-product">
          <page-video
            :contentEnabled="contentEnabled"
            videoSrc="videos/iphone12-video.mp4"
          ></page-video>
          <div class="content">
            <img
              src="./products/iphone-12-mini-logo.svg"
              class="product-logo"
              style="max-width: 25%; margin-top: -2vh"
            />

            <h2>Colourful. Powerful. <br />And barely a handful.</h2>
            <p>
              iPhone 12 mini is the world’s smallest, thinnest and lightest 5G
              phone. Complete with A14 Bionic, the fastest chip in a smartphone.
              A new dual-camera system. And a beautiful Super Retina XDR
              display.
            </p>

            <a
              target="_blank"
              href="https://shop.singtel.com/phones/apple-iphone-12-mini?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=iphone-12mini-buynow&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Buy Now
            </a>
            <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/info/iphone12"
              class="st-button-red-outline page-button"
            >
              Learn More
            </a>
            <!--<a class="st-button-red-outline page-button"> Learn More </a>-->
            <p class="small">T&amp;Cs apply.</p>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  name: "Iphone12MiniPage",
  data: function () {
    return {};
  },
  props: {
    contentEnabled: Boolean,
  },
  methods: {},
};
</script>

<style scoped></style>
